import React, { useState, useEffect } from "react";
import AuthService from "services/auth.service";
import Modal from "components/Modal/Modal";
import { ReactComponent as UserIcon } from "../assets/img/Usericon.svg";
import { ReactComponent as Setting } from "../assets/img/setting-icon.svg";
import { ReactComponent as Help } from "../assets/img/help-circle.svg";
import { ReactComponent as Phone } from "../assets/img/call.svg";
import { ReactComponent as ArrowR } from "../assets/img/arrow-right.svg";
import { API_URL_IMAGE } from "../services/config";
import profile from "../assets/img/profile.png";
import mail from "../assets/img/sms.svg";
import phone from "../assets/img/Vector.png";
import cal from "../assets/img/calendar.png";
import people from "../assets/img/people.png";
import Icon from "../assets/img/icon.png";
import lock from "../assets/img/lock.png";
import viewIcon from "../assets/img/eye.png";
import hideIcon from "../assets/img/invisible.png";

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  FormGroup,
  Form,
  Input,
  Row,
  Col,
} from "reactstrap";

import defaultImage from "../assets/img/default-avatar.png";
import { ImportsNotUsedAsValues } from "typescript";
import icons from "variables/icons";

function User() {
  const currentUser = AuthService.getCurrentUser();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [passwordProfile, setPasswordProfile] = useState("");
  const handleOptionClick = (content) => {
    setModalContent(content);
    setIsModalOpen(true);
  };

  //tabbed route

  const [activeTab, setActiveTab] = useState("Profile");

  useEffect(() => {
    const hash = window.location.hash.substring(1); // Remove the #
    if (hash === "about") {
      setActiveTab("About");
    }
  }, []);

  const [file, setFile] = useState(null);

  const togglePasswordVisibility = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };
  const onChangePasswordSignIn = (e) => {
    setPasswordProfile(e.target.value);
  };
  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile && isValidFileType(selectedFile)) {
      setFile(selectedFile);
    } else {
      alert("Invalid file type. Please upload a SVG, PNG, JPG, or GIF.");
    }
  };

  const isValidFileType = (file) => {
    const validTypes = [
      "image/svg+xml",
      "image/png",
      "image/jpeg",
      "image/gif",
    ];
    return validTypes.includes(file.type);
  };


  const handleIDUpload = async (event, side) => {
  const file = event.target.files[0];
  //console.log(file)
  if (!file) return;

  // Basic validation
  if (file.size > 5 * 1024 * 1024) { // 5MB limit
    alert('File size too large (max 5MB)');
    return;
  }

  const formData = new FormData();
  formData.append('file', file);
  formData.append('side', side);

  try {
    const response = await AuthService.uploadID (currentUser.id, formData);

     if (response && response.imageUrl) {
      const updatedUser = { 
        ...currentUser,
        [`id${side.charAt(0).toUpperCase() + side.slice(1)}URL`]: response.imageUrl,
        verificationStatus: 'pending'
      };

      // Update both localStorage and state
      AuthService.updateCurrentUser(updatedUser);
      setFile(file); // Trigger re-render

    }else {
      throw new Error('Invalid response from server');
    }
    
  } catch (error) {
    console.error('Upload error:', error);
    alert('Upload failed. Please try again.');
  }
};

const handleSubmitVerification = async () => {
  if (!currentUser.idFrontURL || currentUser.idFrontURL.endsWith("none") ||
      !currentUser.idBackURL || currentUser.idBackURL.endsWith("none")) {
    alert('Please upload both front and back of your ID');
    return;
  }

  try {
    await AuthService.submitVerification(currentUser.id);
    alert('Your ID has been submitted for verification!');
    
    // Update verification status
    const updatedUser = { ...currentUser, verificationStatus: 'pending' };
    AuthService.updateCurrentUser(updatedUser);
    
  } catch (error) {
    console.error('Submission error:', error);
    alert('Failed to submit for verification. Please try again.');
  }
};

const handleProfilePictureUpload = async (event) => {
  const file = event.target.files[0];
  if (!file) return;

  // Basic validation
  if (!isValidFileType(file)) {
    alert('Invalid file type. Please upload a PNG, JPG, or JPEG.');
    return;
  }

  if (file.size > 2 * 1024 * 1024) { // 2MB limit
    alert('File size too large (max 2MB)');
    return;
  }

  const formData = new FormData();
  formData.append('file', file);
  formData.append('userId', currentUser.id);

  try {
    const response = await AuthService.updateProfilePicture(formData);
    
    if (response && response.imageUrl) {
      const updatedUser = { 
        ...currentUser,
        imageURL: response.imageUrl
      };

      // Update both localStorage and state
      AuthService.updateCurrentUser(updatedUser);
      setFile(file); // Trigger re-render
      
      alert('Profile picture updated successfully!');
    } else {
      throw new Error('Invalid response from server');
    }
  } catch (error) {
    console.error('Upload error:', error);
    alert('Failed to update profile picture. Please try again.');
  }
};

  // Define tab content for each tab
  const renderContent = () => {
    switch (activeTab) {
      case "Profile":
        return (
          <Row>
            <Col className="jag-web-profile">
              <Card className="card-user">
                <Col>
                  <div
                    className="avatar-container"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "20px",
                    }}
                  >
                    <div className="avatar">
                      <img
                        alt="profile img"
                        className="img-circle img-no-padding img-responsive"
                        src={profileImage}
                      />
                    </div>
                  </div>
                </Col>
                <CardBody>
                  <Form>
                    <Row>
                      <Col className="" md="4">
                        <div className="inputs-1">
                          <div className="input-feild-1">
                            <i class="input-icon">
                              <img src={profile} />{" "}
                            </i>
                            <Input
                              type="text"
                              className="input-control pro-input-control"
                              name="FirstName"
                              value={currentUser.firstName}
                              placeholder="First Name"
                              disabled
                            />
                          </div>
                        </div>
                      </Col>
                      <Col className="" md="4">
                        <div className="inputs-1">
                          <div className="input-feild-1">
                            <i class="input-icon">
                              <img src={profile} />{" "}
                            </i>
                            <Input
                              type="text"
                              className="input-control pro-input-control"
                              name="lastName"
                              placeholder="Last Name"
                              value={currentUser.lastName}
                              disabled
                            />
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="" md="4">
                        <div className="input-feild-1">
                          <i class="input-icon">
                            <img src={mail} />{" "}
                          </i>
                          <Input
                            type="text"
                            className="input-control"
                            name="email"
                            placeholder="Email"
                            value={currentUser.email}
                            disabled
                          />
                        </div>
                      </Col>
                      <Col className="" md="4">
                        <div className="input-feild-1">
                          <i class="input-icon">
                            <img src={phone} />{" "}
                          </i>
                          <Input
                            type="text"
                            className="input-control"
                            name="Phone"
                            placeholder="Phone"
                            value={currentUser.mobileNumber}
                            disabled
                          />
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="" md="4">
                        <div className="input-feild-1">
                          <i class="input-icon">
                            <img src={cal} />{" "}
                          </i>
                          <Input
                            type=""
                            className="input-control"
                            name="dateOfBirth"
                            placeholder="YYYY/MM/DD"
                            value={currentUser.dateOfBirth}
                            disabled
                          />
                        </div>
                      </Col>
                      <Col className="" md="4">
                        <div className="input-feild-1">
                          <i class="input-icon">
                            <img src={people} />{" "}
                          </i>
                          <Input
                            id="gender"
                            type=""
                            name="gender"
                            value={currentUser.gender}
                            className="input-control"
                            placeholder="Gender"
                            disabled
                          >
                            {/* <option value="" disabled hidden>
                  Gender
                </option>
                <option value="male" className="jag-input">
                  Male
                </option>
                <option value="female" className="jag-input">
                  Female
                </option>
                <option value="Prefer not to say" className="jag-input">
                  Prefer not to say
                </option> */}
                          </Input>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="" md="4">
                        <div className="inputs-1">
                          <div className="input-feild-1">
                            <i class="input-icon">
                              <img src={profile} />{" "}
                            </i>
                            <Input
                              type="text"
                              className="input-control pro-input-control"
                              name="address"
                              placeholder="address"
                              value={currentUser.address}
                            />
                          </div>
                        </div>
                      </Col>
                    </Row>

                    <Row>
                      
                      <div className=" button-div-1">
                      <input
                        type="file"
                        id="profilePictureUpload"
                        onChange={handleProfilePictureUpload}
                        accept="image/*"
                        style={{ display: "none" }}
                      />
                      <label
                        htmlFor="profilePictureUpload"
                        className="loginbutton-1 save-but"
                        style={{ color: "white", fontSize: "14px", cursor: "pointer" }}
                      >
                        <span>Update Profile Picture </span>
                      </label>
                      </div>
                        &ensp;
                      <div className=" button-div-1">
                        <button className="loginbutton-1 save-but ">
                          <span>Save Changes</span>
                        </button>
                      </div>
                    
                     
                    </Row>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        );
      //
      // Update your Verification case in renderContent()
      case "Verification":
        return (
          <>
            <Row>
              <Col md="6" className="jag-web-profile">
                <Card className="card-user">
                  <div className="upload-card">
                    <p className="upload-subtitle">
                      <span className="upload-title">ID Card Front</span>
                      <br />
                      <br />
                      Upload the front of your government-issued ID
                    </p>

                    <input
                      type="file"
                      id="idFrontUpload"
                      onChange={(e) => handleIDUpload(e, "front")}
                      accept="image/*,.pdf"
                      style={{ display: "none" }}
                    />

                    <label htmlFor="idFrontUpload" className="upload-button">
                      {currentUser.idFrontURL &&
                      !currentUser.idFrontURL.endsWith("none") ? (
                        <>
                          <img
                            src={`${API_URL_IMAGE}${currentUser.idFrontURL}`}
                            alt="ID Front Preview"
                            className="id-preview"
                          />
                          <br />
                          <br />
                          <span className="replace-text">Replace Front</span>
                        </>
                      ) : (
                        <div className="upload-placeholder">
                          <img src={Icon} alt="Upload icon" />
                          <span>Click to upload</span>
                        </div>
                      )}
                    </label>
                  </div>
                </Card>
              </Col>

              <Col md="6" className="jag-web-profile">
                <Card className="card-user">
                  <div className="upload-card">
                    <p className="upload-subtitle">
                      <span className="upload-title">ID Card Back</span>
                      <br />
                      <br />
                      Upload the back of your government-issued ID
                    </p>

                    <input
                      type="file"
                      id="idBackUpload"
                      onChange={(e) => handleIDUpload(e, "back")}
                      accept="image/*,.pdf"
                      style={{ display: "none" }}
                    />

                    <label htmlFor="idBackUpload" className="upload-button">
                      {currentUser.idBackURL &&
                      !currentUser.idBackURL.endsWith("none") ? (
                        <>
                          <img
                            src={`${API_URL_IMAGE}${currentUser.idBackURL}`}
                            alt="ID Back Preview"
                            className="id-preview"
                          />
                          <br />
                          <br />
                          <span className="replace-text">Replace Back</span>
                        </>
                      ) : (
                        <div className="upload-placeholder">
                          <img src={Icon} alt="Upload icon" />
                          <span>Click to upload</span>
                        </div>
                      )}
                    </label>
                  </div>
                </Card>
              </Col>
            </Row>

            <Row>
              <Col className="verification-status">
                <p>
                  Status:{" "}
                  <span className={`status-${currentUser.verificationStatus || "pending"}`}>
                    {(currentUser.verificationStatus || 'pending').toUpperCase()}
                  </span>
                </p>
                {currentUser.verificationStatus === "rejected" && (
                  <p className="rejection-reason">
                    Note: Your submission was rejected. Please upload clearer
                    images.
                  </p>
                )}
              </Col>
            </Row>

            <Row>
              <div className="button-div-1">
                <button
                  className="loginbutton-1 save-but"
                  onClick={handleSubmitVerification}
                  disabled={
                    !currentUser.idFrontURL ||
                    currentUser.idFrontURL.endsWith("none") ||
                    !currentUser.idBackURL ||
                    currentUser.idBackURL.endsWith("none")
                  }
                >
                  <span>Submit ID for Verification</span>
                </button>
              </div>
            </Row>
          </>
        );
      case "ChangePassword":
        return (
          <Row>
            <Col className="jag-web-profile">
              <Card className="card-user">
                <CardBody>
                  <Form>
                    <Row>
                      <Col className="" md="4">
                        <div className="input-feild-1">
                          {/* <i class="input-icon fa-solid fa-lock"></i> */}

                          <i class="input-icon">
                            <img src={lock} />{" "}
                          </i>
                          <Input
                            type={showPassword ? "text" : "password"}
                            className="input-control"
                            name="password"
                            placeholder="Old Password"
                            value={passwordProfile}
                            onChange={onChangePasswordSignIn}
                          />
                          <i
                            class="input-icon-right his"
                            title="This is a helper"
                            onClick={togglePasswordVisibility}
                          >
                            <img src={showPassword ? hideIcon : viewIcon} />
                          </i>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="" md="4">
                        <div className="input-feild-1">
                          {/* <i class="input-icon fa-solid fa-lock"></i> */}

                          <i class="input-icon">
                            <img src={lock} />{" "}
                          </i>
                          <Input
                            type={showPassword ? "text" : "password"}
                            className="input-control"
                            name="password"
                            placeholder="New Password"
                            value={passwordProfile}
                            onChange={onChangePasswordSignIn}
                          />
                          <i
                            class="input-icon-right his"
                            title="This is a helper"
                            onClick={togglePasswordVisibility}
                          >
                            <img src={showPassword ? hideIcon : viewIcon} />
                          </i>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="" md="4">
                        <div className="input-feild-1">
                          {/* <i class="input-icon fa-solid fa-lock"></i> */}

                          <i class="input-icon">
                            <img src={lock} />{" "}
                          </i>
                          <Input
                            type={showPassword ? "text" : "password"}
                            className="input-control"
                            name="password"
                            placeholder="Re-type Password"
                            value={passwordProfile}
                            onChange={onChangePasswordSignIn}
                          />
                          <i
                            class="input-icon-right his"
                            title="This is a helper"
                            onClick={togglePasswordVisibility}
                          >
                            <img src={showPassword ? hideIcon : viewIcon} />
                          </i>
                        </div>
                      </Col>
                    </Row>

                    <Row>
                      <div className=" button-div-1">
                        <button className="loginbutton-1 save-but ">
                          <span>Save Changes</span>
                        </button>
                      </div>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        );
      case "About":
        return (
          <>
            <div className="wrapper-login-tos tos">
              <div className="container">
                <h3 className="navv-tos">About IAMBP</h3>
              </div>

              <p>1. Who We Are</p>
              <p>
                The{" "}
                <strong>
                  International Massage & Body Professionals Council (IAMBP)
                </strong>{" "}
                is a globally recognized organization dedicated to advancing the
                massage and body profession. We set industry standards,
                certify qualified practitioners, and promote excellence in
                therapeutic care.
              </p>

              <p>2. Our Mission</p>
              <p>
                <strong>2.1 Core Purpose</strong> <br />
                - Elevate professional standards in massage therapy <br />
                - Protect client safety through rigorous certification <br />
                - Advocate for the integration of body into holistic
                healthcare <br />- Foster continuous education and ethical
                practice
              </p>

              <p>3. What We Offer</p>
              <p>
                <strong>3.1 For Practitioners</strong> <br />
                - Accredited certification programs <br />
                - Continuing education courses <br />
                - Professional networking opportunities <br />- Industry
                advocacy and support
              </p>
              <p>
                <strong>3.2 For Clients</strong> <br />
                - Verified directory of qualified professionals <br />
                - Assurance of safety and expertise <br />
                - Resources for informed wellness choices <br />- Dispute
                resolution support
              </p>

              <p>4. Our Standards</p>
              <p>
                <strong>4.1 Certification Requirements</strong> <br />
                - Minimum 500 hours of accredited training <br />
                - Passing score on competency exams <br />
                - Background checks and liability insurance <br />- Commitment
                to ethical guidelines
              </p>

              <p>5. Why Choose IAMBP?</p>
              <p>
                <strong>5.1 Practitioner Benefits</strong> <br />
                - Enhanced credibility and marketability <br />
                - Access to premium education resources <br />
                - Professional development opportunities <br />- Global
                recognition of credentials
              </p>
              <p>
                <strong>5.2 Client Advantages</strong> <br />
                - Assurance of working with vetted experts <br />
                - Consistent quality of care <br />
                - Adherence to safety protocols <br />- Accountability through
                our code of ethics
              </p>

              <p>6. Our Commitment</p>
              <p>
                We pledge to: <br />
                - Maintain the highest professional standards <br />
                - Continuously update our certification criteria <br />
                - Respond to evolving industry needs <br />- Protect both
                practitioners and clients
              </p>

              <p>7. Join Our Community</p>
              <p>
                <strong>For Practitioners:</strong> <br />
                - Apply for certification <br />
                - Access educational resources <br />
                - Connect with peers <br />
                <br />
                <strong>For Clients:</strong> <br />
                - Find a certified professional <br />
                - Learn about therapeutic options <br />- Provide feedback on
                your experiences
              </p>

              <p>8. Contact Us</p>
              <p>
                Have questions? Reach out: <br />
                - Email:  internationalmassagecouncil@gmail.com <br />
                - Phone: (228) 696-4218 <br />- Office Hours: Monday-Friday,
                9AM-5PM EST
              </p>

              <p>
                IAMBP is committed to advancing the art and science of massage
                therapy while ensuring client satisfaction and practitioner
                success.
              </p>
            </div>
          </>
        );
      default:
        return null;
    }
  };

  const tabStyle = (tabNumber) => ({
    padding: "10px 20px",
    cursor: "pointer",
    color: activeTab === tabNumber ? "#220240" : "black",
    backgroundColor: activeTab === tabNumber ? "#F9FAFB" : "transparent",
    fontWeight: activeTab === tabNumber ? "bold" : "normal",
  });

  //logic for profile image

  const imageDir = currentUser.imageURL;
  let profileImage = `${API_URL_IMAGE}${imageDir}`;

  // Check if imageURL ends with 'none', if yes, use the default image
  if (profileImage.endsWith("none")) {
    profileImage = defaultImage;
  }

  return (
    <>
      {/* this is for web  */}
      <div className="content jag-web">
        <Row className="auto-adjust">
          <Col lg="8" md="8" sm="6" className="house-all">
            <div className="typography-line-dash  line-dash-mob welcome-msg ">
              <h2>Settings</h2>
              <p>Your user profile and account settings</p>
            </div>
          </Col>
          <Col lg="8" md="8" sm="6" className="house-all house-monb">
            <div className="set-tab">
              <div
                className="set-tab-unit unit-left"
                style={tabStyle("Profile")}
                onClick={() => setActiveTab("Profile")}
              >
                <span>Profile</span>
              </div>
              <div
                className="set-tab-unit"
                style={tabStyle("Verification")}
                onClick={() => setActiveTab("Verification")}
              >
                <span>Verification</span>
              </div>
              <div
                className="set-tab-unit"
                style={tabStyle("ChangePassword")}
                onClick={() => setActiveTab("ChangePassword")}
              >
                <span>Change Password</span>
              </div>
              <div
                className="set-tab-unit unit-right"
                style={tabStyle("About")}
                onClick={() => setActiveTab("About")}
              >
                <span>About</span>
              </div>
            </div>

            <div style={{ padding: "20px" }}>{renderContent()}</div>
          </Col>
        </Row>
      </div>

      {/* this is for mobile  */}
      {/* <div className="jag-profile">
        <div className="jag-profile-header">
          <h2> User Profile</h2>
        </div>
        <div className="jag-user-profile">
          <img src={profileImage} alt="User Avatar" className="jag-avatar" />
          <div className="jag-user-profile-info">
            <h2>
              {currentUser.firstName} {currentUser.lastName}
            </h2>
            <p>{currentUser.email}</p>
          </div>
        </div>
        <div className="jag-options">
          <div onClick={() => handleOptionClick("My Account")}>
            {" "}
            <UserIcon className="jag-icons" /> My Account{" "}
            <ArrowR className="jag-arwR" />
          </div>
          <div onClick={() => handleOptionClick("Settings")}>
            {" "}
            <Setting className="jag-icons" /> Settings{" "}
            <ArrowR className="jag-arwR" />
          </div>
          <div onClick={() => handleOptionClick("Help Center")}>
            {" "}
            <Help className="jag-icons" />
            Help Center <ArrowR className="jag-arwR" />
          </div>
          <div onClick={() => handleOptionClick("Contact")} className="nild">
            <Phone className="jag-icons" /> Contact{" "}
            <ArrowR className="jag-arwR" />
          </div>
        </div>
        {isModalOpen && (
          <Modal content={modalContent} setIsModalOpen={setIsModalOpen} />
        )}
      </div> */}
    </>
  );
}

export default User;
